// extracted by mini-css-extract-plugin
export default {"numText":"StatsList_numText__QEaVy","statsText":"StatsList_statsText__rM3sf","innerStats":"StatsList_innerStats__9xXWr","infoPopup":"StatsList_infoPopup__RCsKi"};